<template>
  <div class="flex flex-col">
    <router-link
      v-if="hasPermission('edit_product_categories')"
      :to="{ name: 'productsCategoriesCreateForm' }"
      class="primary-button mx-0 mt-4"
      >Crear Categoría</router-link
    >

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white w-full">
        <thead class="text-left">
          <tr class="bg-primary-100">
            <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">ID</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Categoría</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Slug</th>
            <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Publicado</th>
            <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="category in productCategories" :key="category.id" class="table-row">
            <td class="table-cell">{{ category.id }}</td>
            <td class="table-cell">{{ category.name }}</td>
            <td class="table-cell font-mono text-xs">{{ category.slug || '—' }}</td>
            <td class="table-cell">
              <span v-if="category.is_published" class="text-green-600 font-semibold">Sí</span>
              <span v-else class="text-content-400">No</span>
            </td>
            <td class="table-cell">
              <div class="flex space-x-2">
                <router-link
                  :to="{ name: 'productCategoriesDetail', params: { id: category.id } }"
                  class="secondary-button"
                  >Detalle</router-link
                >
                <router-link
                  v-if="hasPermission('edit_product_categories')"
                  :to="{ name: 'productCategoriesEditForm', params: { id: category.id } }"
                  class="secondary-button"
                  >Editar</router-link
                >
                <button
                  v-if="hasPermission('delete_product_categories')"
                  class="delete-button"
                  @click="confirmDelete(category)"
                >Eliminar</button>
              </div>
            </td>
          </tr>
          <tr v-if="productCategories && !productCategories.length">
            <td colspan="5" class="text-center p-4 text-content-300">No hay categorías.</td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>

    <transition name="modal">
      <delete-modal
        v-if="showDeleteModal"
        :loading="loadingDelete"
        @close="closeDeleteModal()"
        @confirmDelete="deleteElement"
      ></delete-modal>
    </transition>
  </div>
</template>

<script>
import api from "@/api";
import deleteMixin from "@/mixins/deleteMixin";
export default {
  name: "Product Categories",

  data() {
    return {
      productCategories: null,
      loading: false,
      loadingDelete: false,
      categoryToDelete: null,
      defaultImage: require("@/assets/paw.png"),
    };
  },

  mixins: [deleteMixin],

  created() {
    this.$store.commit("setStoreSelectedTab", "productCategories");

    this.loadProductCategories();
  },

  methods: {
    async loadProductCategories() {
      this.loading = true;

      try {
        this.productCategories = await api.productCategories.getAll();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    confirmDelete(category) {
      this.categoryToDelete = category;
      this.openDeleteModal();
    },

    async deleteElement() {
      if (!this.categoryToDelete) return;
      this.loadingDelete = true;

      try {
        const response = await api.productCategories.delete(this.categoryToDelete.id);
        this.$store.dispatch("successSnack", response.message);
        this.closeDeleteModal();
        this.categoryToDelete = null;
        await this.loadProductCategories();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingDelete = false;
    },
  },
};
</script>